// Import all images from the changelog directory
import type { MarkdownAssetsMap } from '../components/markdownviewer/types'
import ccdSubpanelViewDark from './2025-08/ccd-subpanel-view.png'
import ccdSubpanelViewLight from './2025-08/ccd-subpanel-view-light.png'
import ccdVisiblePrioritiesDark from './2025-08/ccd-visible-priorities.png'
import ccdVisiblePrioritiesLight from './2025-08/ccd-visible-priorities-light.png'
import hiddenOperationViewDark from './2025-08/hidden-operation-view.png'
import hiddenOperationViewLight from './2025-08/hidden-operation-view-light.png'
import hideOperationsTimeline from './2025-08/hide-operations-timeline.png'
import hideOperationsTimelineLight from './2025-08/hide-operations-timeline-light.png'
import hideTemplateFormDark from './2025-08/hide-template-form.png'
import hideTemplateFormLight from './2025-08/hide-template-form-light.png'
import personaSelectorDark from './2025-08/persona-selector.png'
import personaSelectorLight from './2025-08/persona-selector-light.png'
import serverManagementDark from './2025-08/server-management.png'
import serverManagementLight from './2025-08/server-management-light.png'
import workspaceManagementDark from './2025-08/workspace-management.png'
import workspaceManagementLight from './2025-08/workspace-management-light.png'
import downloadOptionsDark from './2025-09/download-options.png'
import downloadOptionsLight from './2025-09/download-options-light.png'
import functionLiteralDark from './2025-09/function-literal.png'
import functionLiteralLight from './2025-09/function-literal-light.png'
import modelNavigationDark from './2025-09/model-navigation.png'
import modelNavigationLight from './2025-09/model-navigation-light.png'
import changesetOperationLinkDark from './2025-10/changeset-operation-link.png'
import changesetOperationLinkLight from './2025-10/changeset-operation-link-light.png'
import changesetVersionTimelineDark from './2025-10/changeset-version-timeline.png'
import changesetVersionTimelineLight from './2025-10/changeset-version-timeline-light.png'
import changesetVersionTimelineLockedDark from './2025-10/changeset-version-timeline-locked.png'
import changesetVersionTimelineLockedLight from './2025-10/changeset-version-timeline-locked-light.png'
import changesetVisibilityDark from './2025-10/changeset-visibility.png'
import changesetVisibilityLight from './2025-10/changeset-visibility-light.png'
import constructorDemoDark from './2025-10/constructor-demo.mp4'
import constructorDemoLight from './2025-10/constructor-demo-light.mp4'
import hiddenChangesetWarningDark from './2025-10/hidden-changesets-warning.png'
import hiddenChangesetWarningLight from './2025-10/hidden-changesets-warning-light.png'
import enumReviewDark from './2025-11/enum-review.png'
import enumReviewLight from './2025-11/enum-review-light.png'
import itemsFilterDark from './2025-11/items-filter.png'
import itemsFilterLight from './2025-11/items-filter-light.png'
import parameterDefinitionReviewDark from './2025-11/parameter-definition-review.png'
import parameterDefinitionReviewLight from './2025-11/parameter-definition-review-light.png'
import reviewTabDark from './2025-11/review-tab.png'
import reviewTabLight from './2025-11/review-tab-light.png'
import templateNavigationControlsDark from './2025-11/template-navigation-controls.png'
import templateNavigationControlsLight from './2025-11/template-navigation-controls-light.png'
import templateReviewDark from './2025-11/template-review.png'
import templateReviewLight from './2025-11/template-review-light.png'
import tenantReviewDark from './2025-11/tenant-review.png'
import tenantReviewLight from './2025-11/tenant-review-light.png'
import parameterValueOperationsDark from './2025-11/values-operations.png'
import parameterValueOperationsLight from './2025-11/values-operations-light.png'
import parameterValueReviewDark from './2025-11/values-review.png'
import parameterValueReviewLight from './2025-11/values-review-light.png'
import layerEnumLiteralEdit from './2026-02/layer-enum-edit.png'
import layerEnumLiteralEditLight from './2026-02/layer-enum-edit-light.png'
import layerExportsDark from './2026-02/layer-exports.png'
import layerExportsLight from './2026-02/layer-exports-light.png'
import layerIndicatorDark from './2026-02/layer-indicator.png'
import layerIndicatorLight from './2026-02/layer-indicator-light.png'
import layerParameterEdit from './2026-02/layer-parameter-edit.png'
import layerParameterEditLight from './2026-02/layer-parameter-edit-light.png'
import layeredTreeDark from './2026-02/layered-tree.png'
import layeredTreeLight from './2026-02/layered-tree-light.png'
import nonLayeredTreeDark from './2026-02/non-layered-tree.png'
import nonLayeredTreeLight from './2026-02/non-layered-tree-light.png'
import blockExportsDark from './2026-03/block-exports.png'
import blockExportsLight from './2026-03/block-exports-light.png'
import blockFiltering from './2026-03/block-filtering.png'
import blockFilteringLight from './2026-03/block-filtering-light.png'
import blockIndicatorsDark from './2026-03/block-indicators.png'
import blockIndicatorsLight from './2026-03/block-indicators-light.png'
import blockTreeDark from './2026-03/block-tree.png'
import blockTreeByLayerPackage from './2026-03/block-tree-by-layer-package.png'
import blockTreeByLayerPackageLight from './2026-03/block-tree-by-layer-package-light.png'
import blockTreeLight from './2026-03/block-tree-light.png'
import blockAwareOperations from './2026-04/block-aware-operations.png'
import blockAwareOperationsLight from './2026-04/block-aware-operations-light.png'
import branchEditableState from './2026-04/branch-editable-state.png'
import branchEditableStateLight from './2026-04/branch-editable-state-light.png'
import draftLocationSelector from './2026-04/draft-location-selector.png'
import draftLocationSelectorLight from './2026-04/draft-location-selector-light.png'
import inlineDraftButton from './2026-04/inline-draft-button.png'
import inlineDraftButtonLight from './2026-04/inline-draft-button-light.png'
import navigationBreadcrumb from './2026-04/navigation-breadcrumb.png'
import navigationBreadcrumbLight from './2026-04/navigation-breadcrumb-light.png'
import pushDisabledAlerts from './2026-04/push-disabled-alerts.png'
import pushDisabledAlertsLight from './2026-04/push-disabled-alerts-light.png'
import unifiedManagementPanel from './2026-04/unified-management-panel.png'
import unifiedManagementPanelLight from './2026-04/unified-management-panel-light.png'
import workspaceChangesTab from './2026-04/workspace-changes-tab.png'
import workspaceChangesTabLight from './2026-04/workspace-changes-tab-light.png'
import stickyPathBreadcrumb from './2026-05/sticky-path-breadcrumb.png'
import stickyPathBreadcrumbLight from './2026-05/sticky-path-breadcrumb-light.png'
import stickyPathHeader from './2026-05/sticky-path-header.png'
import stickyPathHeaderLight from './2026-05/sticky-path-header-light.png'
import annulmentOperations from './2026-06/annulment-operations.png'
import annulmentOperationsLight from './2026-06/annulment-operations-light.png'
import transferButton from './2026-06/transfer-button.png'
import transferButtonLight from './2026-06/transfer-button-light.png'
import transferConfirmationModal from './2026-06/transfer-confirmation-modal.png'
import transferConfirmationModalLight from './2026-06/transfer-confirmation-modal-light.png'
import revertChangesetHistoryEntry from './2026-07/revert-changeset-history-entry.png'
import revertChangesetHistoryEntryLight from './2026-07/revert-changeset-history-entry-light.png'
import revertChangesetModal from './2026-07/revert-changeset-modal.png'
import revertChangesetModalLight from './2026-07/revert-changeset-modal-light.png'
import revertChangesetWorkspaceChanges from './2026-07/revert-changeset-workspace-changes.png'
import revertChangesetWorkspaceChangesLight from './2026-07/revert-changeset-workspace-changes-light.png'
import fplusComparisonSideBySide from './2026-08/fplus-comparison-side-by-side.png'
import fplusComparisonSideBySideLight from './2026-08/fplus-comparison-side-by-side-light.png'
import fplusComparisonStacked from './2026-08/fplus-comparison-stacked.png'
import fplusComparisonStackedLight from './2026-08/fplus-comparison-stacked-light.png'
import glMapDraftForm from './2026-08/gl-map-draft-form.png'
import glMapDraftFormLight from './2026-08/gl-map-draft-form-light.png'
import glMapTree from './2026-08/gl-map-tree.png'
import glMapTreeLight from './2026-08/gl-map-tree-light.png'
import glMapViewer from './2026-08/gl-map-viewer.png'
import glMapViewerLight from './2026-08/gl-map-viewer-light.png'
import amendmentInChanges from './2026-09/amendment-in-changes.png'
import amendmentInChangesLight from './2026-09/amendment-in-changes-light.png'
import amendmentSelected from './2026-09/amendment-selected.png'
import amendmentSelectedLight from './2026-09/amendment-selected-light.png'
import glMapHiddenView from './2026-09/gl-map-hidden-view.png'
import glMapHiddenViewLight from './2026-09/gl-map-hidden-view-light.png'
import glMapHideForm from './2026-09/gl-map-hide-form.png'
import glMapHideFormLight from './2026-09/gl-map-hide-form-light.png'
import glMapHideTimeline from './2026-09/gl-map-hide-timeline.png'
import glMapHideTimelineLight from './2026-09/gl-map-hide-timeline-light.png'
import outOfSyncDot from './2026-09/out-of-sync-dot.png'
import outOfSyncDotLight from './2026-09/out-of-sync-dot-light.png'

// Map of asset paths to their imported URLs
// This maps relative paths in markdown to the actual imported asset URLs
export const changelogAssetsMap: MarkdownAssetsMap = {
  './2025-08/hide-template-form.png': {
    light: hideTemplateFormLight,
    dark: hideTemplateFormDark,
  },
  './2025-08/hide-operations-timeline.png': {
    light: hideOperationsTimelineLight,
    dark: hideOperationsTimeline,
  },
  './2025-08/hidden-operation-view.png': {
    light: hiddenOperationViewLight,
    dark: hiddenOperationViewDark,
  },
  './2025-08/persona-selector.png': {
    light: personaSelectorLight,
    dark: personaSelectorDark,
  },
  './2025-08/server-management.png': {
    light: serverManagementLight,
    dark: serverManagementDark,
  },
  './2025-08/workspace-management.png': {
    light: workspaceManagementLight,
    dark: workspaceManagementDark,
  },
  './2025-08/ccd-visible-priorities.png': {
    light: ccdVisiblePrioritiesLight,
    dark: ccdVisiblePrioritiesDark,
  },
  './2025-08/ccd-subpanel-view.png': {
    light: ccdSubpanelViewLight,
    dark: ccdSubpanelViewDark,
  },
  './2025-09/download-options.png': {
    light: downloadOptionsLight,
    dark: downloadOptionsDark,
  },
  './2025-09/model-navigation.png': {
    light: modelNavigationLight,
    dark: modelNavigationDark,
  },
  './2025-09/function-literal.png': {
    light: functionLiteralLight,
    dark: functionLiteralDark,
  },
  './2025-10/constructor-demo.mp4': {
    light: constructorDemoLight,
    dark: constructorDemoDark,
  },
  './2025-10/changeset-visibility.png': {
    light: changesetVisibilityLight,
    dark: changesetVisibilityDark,
  },
  './2025-10/changeset-operation-link.png': {
    light: changesetOperationLinkLight,
    dark: changesetOperationLinkDark,
  },
  './2025-10/changeset-version-timeline.png': {
    light: changesetVersionTimelineLight,
    dark: changesetVersionTimelineDark,
  },
  './2025-10/changeset-version-timeline-locked.png': {
    light: changesetVersionTimelineLockedLight,
    dark: changesetVersionTimelineLockedDark,
  },
  './2025-10/hidden-changesets-warning.png': {
    light: hiddenChangesetWarningLight,
    dark: hiddenChangesetWarningDark,
  },
  './2025-11/items-filter.png': {
    light: itemsFilterLight,
    dark: itemsFilterDark,
  },
  './2025-11/review-tab.png': {
    light: reviewTabLight,
    dark: reviewTabDark,
  },
  './2025-11/template-review.png': {
    light: templateReviewLight,
    dark: templateReviewDark,
  },
  './2025-11/parameter-definition-review.png': {
    light: parameterDefinitionReviewLight,
    dark: parameterDefinitionReviewDark,
  },
  './2025-11/values-review.png': {
    light: parameterValueReviewLight,
    dark: parameterValueReviewDark,
  },
  './2025-11/values-operations.png': {
    light: parameterValueOperationsLight,
    dark: parameterValueOperationsDark,
  },
  './2025-11/enum-review.png': {
    light: enumReviewLight,
    dark: enumReviewDark,
  },
  './2025-11/tenant-review.png': {
    light: tenantReviewLight,
    dark: tenantReviewDark,
  },
  './2025-11/template-navigation-controls.png': {
    light: templateNavigationControlsLight,
    dark: templateNavigationControlsDark,
  },
  './2026-02/layered-tree.png': {
    light: layeredTreeLight,
    dark: layeredTreeDark,
  },
  './2026-02/layer-indicator.png': {
    light: layerIndicatorLight,
    dark: layerIndicatorDark,
  },
  './2026-02/layer-exports.png': {
    light: layerExportsLight,
    dark: layerExportsDark,
  },
  './2026-02/non-layered-tree.png': {
    light: nonLayeredTreeLight,
    dark: nonLayeredTreeDark,
  },
  './2026-02/layer-enum-edit.png': {
    light: layerEnumLiteralEditLight,
    dark: layerEnumLiteralEdit,
  },
  './2026-02/layer-parameter-edit.png': {
    light: layerParameterEditLight,
    dark: layerParameterEdit,
  },
  './2026-03/block-tree.png': {
    light: blockTreeLight,
    dark: blockTreeDark,
  },
  './2026-03/block-indicators.png': {
    light: blockIndicatorsLight,
    dark: blockIndicatorsDark,
  },
  './2026-03/block-exports.png': {
    light: blockExportsLight,
    dark: blockExportsDark,
  },
  './2026-03/block-tree-by-layer-package.png': {
    light: blockTreeByLayerPackageLight,
    dark: blockTreeByLayerPackage,
  },
  './2026-03/block-filtering.png': {
    light: blockFilteringLight,
    dark: blockFiltering,
  },
  './2026-04/workspace-changes-tab.png': {
    light: workspaceChangesTabLight,
    dark: workspaceChangesTab,
  },
  './2026-04/push-disabled-alerts.png': {
    light: pushDisabledAlertsLight,
    dark: pushDisabledAlerts,
  },
  './2026-04/draft-location-selector.png': {
    light: draftLocationSelectorLight,
    dark: draftLocationSelector,
  },
  './2026-04/block-aware-operations.png': {
    light: blockAwareOperationsLight,
    dark: blockAwareOperations,
  },
  './2026-04/branch-editable-state.png': {
    light: branchEditableStateLight,
    dark: branchEditableState,
  },
  './2026-04/unified-management-panel.png': {
    light: unifiedManagementPanelLight,
    dark: unifiedManagementPanel,
  },
  './2026-04/navigation-breadcrumb.png': {
    light: navigationBreadcrumbLight,
    dark: navigationBreadcrumb,
  },
  './2026-04/inline-draft-button.png': {
    light: inlineDraftButtonLight,
    dark: inlineDraftButton,
  },
  './2026-05/sticky-path-header.png': {
    light: stickyPathHeaderLight,
    dark: stickyPathHeader,
  },
  './2026-05/sticky-path-breadcrumb.png': {
    light: stickyPathBreadcrumbLight,
    dark: stickyPathBreadcrumb,
  },
  './2026-06/transfer-button.png': {
    light: transferButtonLight,
    dark: transferButton,
  },
  './2026-06/transfer-confirmation-modal.png': {
    light: transferConfirmationModalLight,
    dark: transferConfirmationModal,
  },
  './2026-06/annulment-operations.png': {
    light: annulmentOperationsLight,
    dark: annulmentOperations,
  },
  './2026-07/revert-changeset-history-entry.png': {
    light: revertChangesetHistoryEntryLight,
    dark: revertChangesetHistoryEntry,
  },
  './2026-07/revert-changeset-modal.png': {
    light: revertChangesetModalLight,
    dark: revertChangesetModal,
  },
  './2026-07/revert-changeset-workspace-changes.png': {
    light: revertChangesetWorkspaceChangesLight,
    dark: revertChangesetWorkspaceChanges,
  },
  './2026-08/fplus-comparison-side-by-side.png': {
    light: fplusComparisonSideBySideLight,
    dark: fplusComparisonSideBySide,
  },
  './2026-08/fplus-comparison-stacked.png': {
    light: fplusComparisonStackedLight,
    dark: fplusComparisonStacked,
  },
  './2026-08/gl-map-tree.png': {
    light: glMapTreeLight,
    dark: glMapTree,
  },
  './2026-08/gl-map-viewer.png': {
    light: glMapViewerLight,
    dark: glMapViewer,
  },
  './2026-08/gl-map-draft-form.png': {
    light: glMapDraftFormLight,
    dark: glMapDraftForm,
  },
  './2026-09/amendment-in-changes.png': {
    light: amendmentInChangesLight,
    dark: amendmentInChanges,
  },
  './2026-09/amendment-selected.png': {
    light: amendmentSelectedLight,
    dark: amendmentSelected,
  },
  './2026-09/gl-map-hide-form.png': {
    light: glMapHideFormLight,
    dark: glMapHideForm,
  },
  './2026-09/gl-map-hide-timeline.png': {
    light: glMapHideTimelineLight,
    dark: glMapHideTimeline,
  },
  './2026-09/gl-map-hidden-view.png': {
    light: glMapHiddenViewLight,
    dark: glMapHiddenView,
  },
  './2026-09/out-of-sync-dot.png': {
    light: outOfSyncDotLight,
    dark: outOfSyncDot,
  },
}
